import React, { createContext } from 'react';
import {
  IToggleButtonGroupContext,
  IToggleButtonGroupProps,
  IToggleButtonGroupComposition,
} from './types';
import { ButtonContainer } from '../buttonContainer';
import { ToggleButton } from './toggleButton';

export const ToggleButtonGroupContext = createContext<
  IToggleButtonGroupContext | undefined
>(undefined);

export const ToggleButtonGroup: React.FC<IToggleButtonGroupProps> &
  IToggleButtonGroupComposition = ({ activeKey, children, onChange }) => (
  <ToggleButtonGroupContext.Provider
    value={{
      activeKey,
      setActiveKey: onChange,
    }}
  >
    <ButtonContainer align="center" retainOrderOnMobile>
      {children}
    </ButtonContainer>
  </ToggleButtonGroupContext.Provider>
);

ToggleButtonGroup.Button = ToggleButton;
